import * as IconSelector from '../icons';

// Constantes exportadas
export const VALIDATION_TASK_POR_VALIDAR = 'Por Validar';
export const VALIDATION_TASK_VALIDADA = 'Validada';
export const VALIDATION_TASK_RECHAZADA = 'Rechazada';

// Definición del enum
export const validationsTask = [
    {
        value: null,
        label: 'Sin definir',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: VALIDATION_TASK_POR_VALIDAR,
        label: 'Por Validar',
        description: 'tareas pendientes de validar',
        icon: IconSelector.ToVerifiedIcon,
        color: 'DarkOrange'
    },
    {
        value: VALIDATION_TASK_VALIDADA,
        label: 'Validada',
        description: 'tareas asignadas finalizadas y validadas',
        icon: IconSelector.VerifiedIcon,
        color: 'Green'
    },
    {
        value: VALIDATION_TASK_RECHAZADA,
        label: 'Rechazada',
        description: 'tareas asignadas finalizadas pero rechazadas',
        icon: IconSelector.RejectIcon,
        color: 'DarkRed'
    }
];
